import { Injector } from '@angular/core';

export class AppUtils {

  public static injector: Injector;
}
